var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras1)?_c('div',{staticClass:"banner-new",style:({
    background:
      _vm.extras1.formBgWap && _vm.extras1.formBgWap.colorOrBg == 'color'
        ? _vm.extras.formBgWap.color
        : '',
  })},[_c('img',{attrs:{"src":_vm.extras1.formBgWap && _vm.extras1.formBgWap.colorOrBg == 'src'
        ? _vm.extras.formBgWap.src
        : '',"alt":""}}),_c('div',[(_vm.textSettingWap.display == '1')?_c('div',{staticClass:"seminar-info"},[_c('div',{staticClass:"seminar-info-new wap",class:_vm.extras1.BannerText && _vm.extras1.BannerText.textAlign},[_c('div',{staticClass:"content"},[(_vm.textSettingWap.subTitleWap != 'hide')?_c('div',{staticClass:"seminar-title",style:({
              color:
                _vm.textSettingWap.subTitleWap == 'custom'
                  ? _vm.textSettingWap.subTitleWapFontColor
                  : '',

              'font-size':
                _vm.textSettingWap.subTitleWap == 'custom'
                  ? _vm.textSettingWap.subTitleWapFontSize + 'px'
                  : '',
              'font-weight':
                _vm.textSettingWap.subTitleWap == 'custom'
                  ? _vm.textSettingWap.subTitleWapFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                _vm.textSettingWap.subTitleWap == 'custom'
                  ? _vm.textSettingWap.subTitleWapFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            })},[_vm._v(" "+_vm._s(_vm.getSubTitleText())+" ")]):_vm._e(),(_vm.textSettingWap.titleWap != 'hide')?_c('div',{staticClass:"seminar-slogan",style:({
              color:
                _vm.textSettingWap.titleWap == 'custom'
                  ? _vm.textSettingWap.titleWapFontColor
                  : '',
              'font-size':
                _vm.textSettingWap.titleWap == 'custom'
                  ? _vm.textSettingWap.titleWapFontSize + 'px'
                  : '',
              'font-weight':
                _vm.textSettingWap.titleWap == 'custom'
                  ? _vm.textSettingWap.titleWapFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                _vm.textSettingWap.titleWap == 'custom'
                  ? _vm.textSettingWap.titleWapFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            })},[_vm._v(" "+_vm._s(_vm.textSettingWap && _vm.textSettingWap.titleWap == "default" ? _vm.seminarInfo.title : _vm.seminarInfo.title)+" ")]):_vm._e(),_c('div',{staticClass:"semianr-time"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.textSettingWap.timeTitleWap != 'hide'),expression:"textSettingWap.timeTitleWap != 'hide'"}],staticClass:"_title",style:({
                color:
                  _vm.textSettingWap.timeTitleWap == 'custom'
                    ? _vm.textSettingWap.timeTitleWapFontColor
                    : '',
                'font-size':
                  _vm.textSettingWap.timeTitleWap == 'custom'
                    ? _vm.textSettingWap.timeTitleWapFontSize + 'px'
                    : '',
                'font-weight':
                  _vm.textSettingWap.timeTitleWap == 'custom'
                    ? _vm.textSettingWap.timeTitleWapFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  _vm.textSettingWap.timeTitleWap == 'custom'
                    ? _vm.textSettingWap.timeTitleWapFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  _vm.textSettingWap && _vm.textSettingWap.titleBgColorWap
                    ? _vm.textSettingWap.titleBgColorWap
                    : 'transparent',
              })},[_vm._v(" "+_vm._s(_vm.getTimeTitleText())+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.textSettingWap.timeWap != 'hide'),expression:"textSettingWap.timeWap != 'hide'"}],staticClass:"_time",style:({
                color:
                  _vm.textSettingWap.timeWap == 'custom'
                    ? _vm.textSettingWap.timeWapFontColor
                    : '',
                'font-size':
                  _vm.textSettingWap.timeWap == 'custom'
                    ? _vm.textSettingWap.timeWapFontSize + 'px'
                    : '',
                'font-weight':
                  _vm.textSettingWap.timeWap == 'custom'
                    ? _vm.textSettingWap.timeWapFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  _vm.textSettingWap.timeWap == 'custom'
                    ? _vm.textSettingWap.timeWapFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  _vm.textSettingWap && _vm.textSettingWap.timeBgColorWap
                    ? _vm.textSettingWap.timeBgColorWap
                    : 'transparent',
              })},[_vm._v(" "+_vm._s(_vm.getTimeText())+" ")])]),_c('div',{staticClass:"semianr-time"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.textSettingWap.addressTitleWap != 'hide'),expression:"textSettingWap.addressTitleWap != 'hide'"}],staticClass:"_title",style:({
                color:
                  _vm.textSettingWap.addressTitleWap == 'custom'
                    ? _vm.textSettingWap.addressTitleWapFontColor
                    : '',
                'font-size':
                  _vm.textSettingWap.addressTitleWap == 'custom'
                    ? _vm.textSettingWap.addressTitleWapFontSize + 'px'
                    : '',
                'font-weight':
                  _vm.textSettingWap.addressTitleWap == 'custom'
                    ? _vm.textSettingWap.addressTitleWapFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  _vm.textSettingWap.addressTitleWap == 'custom'
                    ? _vm.textSettingWap.addressTitleWapFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  _vm.textSettingWap && _vm.textSettingWap.titleBgColorWap
                    ? _vm.textSettingWap.titleBgColorWap
                    : 'transparent',
              })},[_vm._v(" "+_vm._s(_vm.getAddressTitleText())+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.textSettingWap.addressWap != 'hide'),expression:"textSettingWap.addressWap != 'hide'"}],staticClass:"_time",style:({
                color:
                  _vm.textSettingWap.addressWap == 'custom'
                    ? _vm.textSettingWap.addressWapFontColor
                    : '',
                'font-size':
                  _vm.textSettingWap.addressWap == 'custom'
                    ? _vm.textSettingWap.addressWapFontSize + 'px'
                    : '',
                'font-weight':
                  _vm.textSettingWap.addressWap == 'custom'
                    ? _vm.textSettingWap.addressWapFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  _vm.textSettingWap.addressWap == 'custom'
                    ? _vm.textSettingWap.addressWapFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  _vm.textSettingWap && _vm.textSettingWap.addressBgColorWap
                    ? _vm.textSettingWap.addressBgColorWap
                    : 'transparent',
              })},[_vm._v(" "+_vm._s(_vm.getAddressText())+" ")])])])])]):_vm._e()])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }